import request from '@/utils/request'

// 短信
export function send_phone_code(data) {
  return request({
    url: process.env.VUE_APP_BASE_API_HELPER + '/message/send_phone_code.do',
    method: 'post',
    data
  })
}
// 短信
export function phone_code(data, param) {
  return request({
    url: process.env.VUE_APP_BASE_API_HELPER + '/message/phone_code.do?' + param,
    method: 'post',
    data
  })
}
// 获取游戏列表
export function game_list() {
  return request({
    url: process.env.VUE_APP_BASE_API_HELPER + '/new/account/appeal/game_list.do',
    method: 'get'
  })
}
// 第一步提交，请求校验用户和是否需要人脸
export function check_user(data) {
  return request({
    url: process.env.VUE_APP_BASE_API_HELPER + '/new/account/appeal/check_user.do',
    method: 'post',
    data
  })
}

// 触发人脸流程：查询人脸认证结果
export function check_face(data) {
  return request({
    url: process.env.VUE_APP_BASE_API_HELPER + '/new/account/appeal/check_face.do',
    method: 'post',
    data
  })
}
// 手动申诉第二步提交，提交身份证相关信息
export function submit(data) {
  return request({
    url: process.env.VUE_APP_BASE_API_HELPER + '/new/account/appeal/submit.do',
    method: 'post',
    headers: {
      'Referer': window.origin
    },
    data
  })
}
// 查询进度
export function query(data) {
  return request({
    url: process.env.VUE_APP_BASE_API_HELPER + '/new/account/appeal/query.do',
    method: 'post',
    data
  })
}

// 查询进度
export function get_face(data) {
  return request({
    url: process.env.VUE_APP_BASE_API_HELPER + '/new/account/appeal/get_face.do',
    method: 'post',
    data
  })
}
